import React, { useRef, useLayoutEffect, useState } from "react";
import PropTypes from 'prop-types';

const ArrowPipeline = ({
    stages,
    currentStage,
    onStageClick,
    completedColor = "#0d6efd",
    upcomingColor = "#d3d3d3",
    arrowHeight = 50,
    disabledItem,
    displayData,
    pipeLineStage,
    oldPipeline, makeEdit,
    UpdatePs, canUpdateDelete,
}) => {

    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    useLayoutEffect(() => {
        if (!containerRef.current) return;

        const resizeObserver = new ResizeObserver(() => {
            if (containerRef.current) {
                setContainerWidth(containerRef.current.offsetWidth);
            }
        });

        resizeObserver.observe(containerRef.current);
        setContainerWidth(containerRef.current.offsetWidth);

        return () => resizeObserver.disconnect();
    }, []);

    const arrowWidth = containerWidth / stages.length;

    return (
        // <div ref={containerRef} style={{ width: "100%" }}>
        //     <svg height={arrowHeight} width={containerWidth} style={{ fontFamily: "sans-serif" }}>
        //         {stages.map((stage, i) => {
        //             const { pipelineStageId, pipelineStageName } = stage;
        //             const isLast = i === stages.length - 1;
        //             const isFirst = i === 0;
        //             // const isCompleted = i <= currentStage - 1;
        //             const x = i * arrowWidth;

        //             let points;
        //             if (isFirst) {
        //                 points = `${x},0 ${x + arrowWidth - 10},0 ${x + arrowWidth},${arrowHeight / 2} ${x + arrowWidth - 10},${arrowHeight} ${x},${arrowHeight}`;
        //             } else if (isLast) {
        //                 points = `${x},0 ${x + arrowWidth},0 ${x + arrowWidth},${arrowHeight} ${x},${arrowHeight} ${x + 10},${arrowHeight / 2}`;
        //             } else {
        //                 points = `${x},0 ${x + arrowWidth - 10},0 ${x + arrowWidth},${arrowHeight / 2} ${x + arrowWidth - 10},${arrowHeight} ${x},${arrowHeight} ${x + 10},${arrowHeight / 2}`;
        //             }

        //             return (
        //                 <g
        //                     key={pipelineStageId}
        //                     onClick={() => !canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId) ? undefined :
        //                         displayData?.approved_for === "None" ?
        //                             (makeEdit|| disabledItem || i === currentStage - 1) ? undefined : onStageClick(pipelineStageId, pipelineStageName) : undefined}
        //                     onMouseEnter={() => !canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId) ? undefined : displayData?.approved_for === "None" ? setHoveredIndex(i) : undefined}
        //                     onMouseLeave={() => !canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId) ? undefined : displayData?.approved_for === "None" ? setHoveredIndex(null) : undefined}
        //                     style={{
        //                         cursor: !canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId) ? "default" :
        //                             displayData?.approved_for === "None" ?
        //                                 (makeEdit || disabledItem || i === currentStage - 1) ? "default" : "pointer" : "default"
        //                     }}
        //                 >
        //                     <polygon points={points} fill={
        //                         !canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId) ? upcomingColor :
        //                             displayData?.approved_for === "None" ?
        //                                 hoveredIndex !== null
        //                                     ? i <= hoveredIndex
        //                                         ? completedColor // Hover color
        //                                         : upcomingColor
        //                                     :
        //                                     oldPipeline !== null ?
        //                                         i <= pipeLineStage.findIndex(stage => stage.pipelineStageId === oldPipeline) ? completedColor : upcomingColor
        //                                         : i <= pipeLineStage.findIndex(stage => stage.pipelineStageId === currentStage) ? completedColor : upcomingColor
        //                                 : upcomingColor
        //                     } />
        //                     <text
        //                         fontFamily="'Noto Sans', sans-serif"
        //                         x={x + arrowWidth / 2}
        //                         y={arrowHeight / 2}
        //                         textAnchor="middle"
        //                         fill={
        //                             !canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId) ? "#a1a1a1" :
        //                             displayData?.approved_for === "None" ?
        //                                 hoveredIndex !== null
        //                                     ? i <= hoveredIndex
        //                                         ? "#ffffff" // Hover color
        //                                         : "#a1a1a1"
        //                                     :
        //                                     oldPipeline !== null ?
        //                                         i <= pipeLineStage.findIndex(stage => stage.pipelineStageId === oldPipeline) ? "#ffffff" : "#a1a1a1"
        //                                         : i <= pipeLineStage.findIndex(stage => stage.pipelineStageId === currentStage) ? "#ffffff" : "#a1a1a1"
        //                                         :"#a1a1a1"
        //                         }
        //                         fontSize="12"
        //                         fontWeight="600"
        //                         dominantBaseline="middle"
        //                     >
        //                         {pipelineStageName}
        //                     </text>
        //                 </g>
        //             );
        //         })}
        //     </svg>
        // </div>
        <div ref={containerRef} style={{ width: "100%" }}>
            <svg height={arrowHeight} width={containerWidth} style={{ fontFamily: "sans-serif" }}>
                {stages.map((stage, i) => {
                    const { pipelineStageId, pipelineStageName } = stage;
                    const x = i * arrowWidth;
                    const isFirst = i === 0;
                    const isLast = i === stages.length - 1;
                    const isCurrent = i === currentStage - 1;

                    const canEdit = canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId);
                    const isApprovedNone = displayData?.approved_for === "None";
                    const isInteractive = canEdit && isApprovedNone && !makeEdit && !disabledItem && !isCurrent;

                    // Shape points
                    let points;
                    if (isFirst) {
                        points = `${x},0 ${x + arrowWidth - 10},0 ${x + arrowWidth},${arrowHeight / 2} ${x + arrowWidth - 10},${arrowHeight} ${x},${arrowHeight}`;
                    } else if (isLast) {
                        points = `${x},0 ${x + arrowWidth},0 ${x + arrowWidth},${arrowHeight} ${x},${arrowHeight} ${x + 10},${arrowHeight / 2}`;
                    } else {
                        points = `${x},0 ${x + arrowWidth - 10},0 ${x + arrowWidth},${arrowHeight / 2} ${x + arrowWidth - 10},${arrowHeight} ${x},${arrowHeight} ${x + 10},${arrowHeight / 2}`;
                    }

                    // Fill Color Logic
                    const fillColor = (() => {
                        if (!canEdit) return upcomingColor;
                        if (!isApprovedNone) return upcomingColor;

                        if (hoveredIndex !== null) {
                            return i <= hoveredIndex ? completedColor : upcomingColor;
                        }

                        const referenceStage = oldPipeline !== null ? oldPipeline : currentStage;
                        const referenceIndex = pipeLineStage.findIndex(stage => stage.pipelineStageId === referenceStage);
                        return i <= referenceIndex ? completedColor : upcomingColor;
                    })();

                    // Text Fill Color
                    const textColor = (() => {
                        if (!canEdit) return "#a1a1a1";
                        if (!isApprovedNone) return "#a1a1a1";

                        if (hoveredIndex !== null) {
                            return i <= hoveredIndex ? "#ffffff" : "#a1a1a1";
                        }

                        const referenceStage = oldPipeline !== null ? oldPipeline : currentStage;
                        const referenceIndex = pipeLineStage.findIndex(stage => stage.pipelineStageId === referenceStage);
                        return i <= referenceIndex ? "#ffffff" : "#a1a1a1";
                    })();
                    return (
                        <g
                            key={pipelineStageId}
                            onClick={() => isInteractive && onStageClick(pipelineStageId, pipelineStageName)}
                            onMouseEnter={() => isInteractive && setHoveredIndex(i)}
                            onMouseLeave={() => isInteractive && setHoveredIndex(null)}
                            style={{ cursor: isInteractive ? "pointer" : "default" }}
                        >
                            <polygon points={points} fill={fillColor} />
                            <text
                                fontFamily="'Noto Sans', sans-serif"
                                x={x + arrowWidth / 2}
                                y={arrowHeight / 2}
                                textAnchor="middle"
                                fill={textColor}
                                fontSize="12"
                                fontWeight="600"
                                dominantBaseline="middle"
                            >
                                {pipelineStageName}
                            </text>
                        </g>
                    );
                })}
            </svg>
        </div>
    );
};

ArrowPipeline.propTypes = {
    stages: PropTypes.arrayOf(PropTypes.string).isRequired,
    currentStage: PropTypes.number.isRequired,
    onStageClick: PropTypes.func,
    completedColor: PropTypes.string,
    upcomingColor: PropTypes.string,
    arrowHeight: PropTypes.number,
    oldPipeline: PropTypes.number,
    disabledItem: PropTypes.bool,
    makeEdit: PropTypes.bool,
    displayData: PropTypes.object,
    pipeLineStage: PropTypes.array,
    UpdatePs: PropTypes.object.isRequired,
    canUpdateDelete: PropTypes.func.isRequired,
};

export default ArrowPipeline;
